import { useState, useCallback } from 'react';
import { useInjection } from '../ioc/use-injection';
import INJECTION_TOKENS from '../../../core/generic/ioc/injection-tokens';
import {
  YoutubeOptimizerPort,
  YoutubeOptimizerResult,
} from '../../../core/port/youtube-optimizer.port';

export interface UseYoutubeOptimizerReturn {
  launchOptimizer: () => Promise<void>;
  result: YoutubeOptimizerResult | null;
  isLoading: boolean;
  error: string | null;
}

export function useYoutubeOptimizer(): UseYoutubeOptimizerReturn {
  const [result, setResult] = useState<YoutubeOptimizerResult | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const youtubeOptimizerPort = useInjection<YoutubeOptimizerPort>(
    INJECTION_TOKENS.YOUTUBE_OPTIMIZER_PORT
  );

  const launchOptimizer = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    setResult(null);

    try {
      const optimizerResult = await youtubeOptimizerPort.checkAndLaunchPerformanceOptimizer();
      setResult(optimizerResult);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, [youtubeOptimizerPort]);

  return {
    launchOptimizer,
    result,
    isLoading,
    error,
  };
}
